export function isDevelopmentEnvironment(): boolean {
  return false;
}
